import type { SVGProps } from 'react'

interface SyntheticRadarIconProps extends SVGProps<SVGSVGElement> {}

export function SyntheticRadarIcon(props: SyntheticRadarIconProps) {
  return (
    <svg
      width={78}
      height={56}
      viewBox="0 0 78 56"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M47.31 24.667l.105 3.701.887.829 3.748-2.163v-3.8l-4.74 1.433z"
        fill="currentColor"
      />
      <path
        d="M46.58 20.183l3.143-.973 2.327 4.024-3.747 2.163-3.17-4.024 1.447-1.19z"
        fill="currentColor"
      />
      <path
        d="M46.435 17.31l-3.748 2.163.526 1.847 2.762.053 3.747-2.163-3.287-1.9z"
        fill="currentColor"
      />
      <path
        d="M45.975 21.373l-3.287-1.9-2.328 1.341v3.794l2.328 4.03 3.287 1.9 2.327-1.341v-3.8l-2.327-4.024zM9.85 13.366l.072-.125 4.253-3.583.48-4.622.073-.119 11.242 4.74 12.478 8.948-.072.125-2.893 3.59-1.847 4.615-.066.118-13.05-5.575-10.67-8.113z"
        fill="currentColor"
      />
      <path
        d="M14.503 15.89l-4.582-2.65 4.733-8.204 4.59 2.65-.79 1.616-3.24 5.497-.71 1.09z"
        fill="currentColor"
      />
      <path
        d="M19.233 7.686l-4.73 8.208.178.102 4.73-8.208-.178-.102z"
        fill="currentColor"
      />
      <path
        d="M19.243 18.625l-4.582-2.65 4.734-8.204 4.582 2.649-.782 1.617-3.248 5.496-.704 1.092z"
        fill="currentColor"
      />
      <path
        d="M23.982 10.42l-4.74 8.203.177.102 4.74-8.203-.177-.102z"
        fill="currentColor"
      />
      <path
        d="M23.977 21.36l-4.582-2.65 4.74-8.204 4.582 2.65-.789 1.616-3.241 5.496-.71 1.092z"
        fill="currentColor"
      />
      <path
        d="M24.16 21.465l-.183-.105 4.74-8.205.177.099-4.733 8.211z"
        fill="currentColor"
      />
      <path
        d="M28.717 24.095l-4.582-2.65 4.74-8.204 4.582 2.649-.789 1.617-3.24 5.496-.71 1.092z"
        fill="currentColor"
      />
      <path
        d="M33.461 15.888l-4.74 8.203.177.102 4.74-8.203-.177-.102z"
        fill="currentColor"
      />
      <path
        d="M33.456 26.83l-4.582-2.643 4.74-8.205 4.582 2.643-.788 1.617-3.242 5.496-.71 1.091z"
        fill="currentColor"
      />
      <path
        d="M33.634 26.935l-.178-.105 4.74-8.205.178.105-4.74 8.205zM11.598 20.926l-4.582-2.65 2.833-4.91 4.582 2.642-.788 1.618-1.335 2.202-.71 1.098z"
        fill="currentColor"
      />
      <path
        d="M14.432 16.005L11.6 20.92l.176.102 2.833-4.916-.177-.102z"
        fill="currentColor"
      />
      <path
        d="M16.338 23.66l-4.582-2.649 2.833-4.91 4.583 2.642-.79 1.617-1.34 2.21-.704 1.09z"
        fill="currentColor"
      />
      <path
        d="M19.177 18.749l-2.84 4.912.177.102 2.84-4.912-.177-.102z"
        fill="currentColor"
      />
      <path
        d="M21.078 26.396l-4.582-2.65 2.834-4.91 4.582 2.642-.789 1.624-1.341 2.203-.704 1.09z"
        fill="currentColor"
      />
      <path
        d="M23.91 21.484l-2.84 4.91.176.103 2.84-4.911-.176-.102z"
        fill="currentColor"
      />
      <path
        d="M25.812 29.13l-4.582-2.642 2.833-4.918 4.589 2.643-.789 1.624-1.341 2.202-.71 1.091z"
        fill="currentColor"
      />
      <path
        d="M25.996 29.236l-.184-.105 2.84-4.918.177.105-2.833 4.918z"
        fill="currentColor"
      />
      <path
        d="M30.552 31.866l-4.582-2.643 2.833-4.918 4.583 2.65-.783 1.617-1.341 2.202-.71 1.092z"
        fill="currentColor"
      />
      <path
        d="M30.736 31.97l-.184-.104 2.833-4.911.184.098-2.833 4.918zM19.309 7.56l-4.582-2.643L17.56 0l4.589 2.65-.789 1.616-1.341 2.203-.71 1.091z"
        fill="currentColor"
      />
      <path
        d="M22.15 2.648l-2.838 4.913.176.102 2.838-4.913-.176-.102z"
        fill="currentColor"
      />
      <path
        d="M24.05 10.295l-4.583-2.643L22.3 2.735l4.583 2.65L26.1 7l-1.34 2.203-.71 1.091z"
        fill="currentColor"
      />
      <path
        d="M26.886 5.385l-2.831 4.917.176.102 2.831-4.917-.177-.102z"
        fill="currentColor"
      />
      <path
        d="M28.79 13.037l-4.583-2.65 2.834-4.918 4.582 2.65-.79 1.617-1.34 2.203-.704 1.098z"
        fill="currentColor"
      />
      <path
        d="M31.622 8.116l-2.833 4.916.177.102 2.832-4.916-.176-.102z"
        fill="currentColor"
      />
      <path
        d="M33.53 15.765l-4.59-2.643 2.84-4.918 4.583 2.65-.79 1.617-1.34 2.203-.704 1.09z"
        fill="currentColor"
      />
      <path
        d="M36.364 10.862l-2.84 4.912.177.102 2.84-4.912-.177-.102z"
        fill="currentColor"
      />
      <path
        d="M38.27 18.506l-4.59-2.649 2.834-4.917 4.59 2.649-.79 1.617-1.341 2.203-.703 1.098z"
        fill="currentColor"
      />
      <path
        d="M41.107 13.592l-2.85 4.906.176.102 2.85-4.905-.176-.103zM36.936 23.924l-1.348-.776.48-.835 1.354.782-.131.467-.355.362z"
        fill="currentColor"
      />
      <path
        d="M37.418 23.097l-.48.831.176.102.48-.83-.176-.103zM49.117 33.292l-4.562 2.63V24.877l4.562-2.636v11.051z"
        fill="currentColor"
      />
      <path
        d="M40.137 23.746l4.418 1.131 4.562-2.636-9.565-5.523-4.57 2.637 5.155 4.391z"
        fill="currentColor"
      />
      <path
        d="M44.555 35.922L34.982 30.4V19.355l9.573 5.522v11.045z"
        fill="currentColor"
      />
      <path
        d="M35.53 31.721l.13 4.392 1.046.98 7.653-4.419v-4.503l-8.83 3.55z"
        fill="currentColor"
      />
      <path
        d="M34.668 26.402l6.936-3.004 2.755 4.773-7.653 4.418-3.754-4.773 1.716-1.414z"
        fill="currentColor"
      />
      <path
        d="M37.705 21.15l-7.652 4.417.618 2.19 3.28.059 7.653-4.418-3.899-2.249z"
        fill="currentColor"
      />
      <path
        d="M33.95 27.816l-3.898-2.249-2.761 1.591v4.497l2.761 4.78 3.899 2.248 2.754-1.59v-4.504l-2.754-4.773zM16.988 49.3l-1.13.461-1.591-3.425v-.618l1.275.486 1.446 3.097zM38.02 45.718v.618l-1.591 3.425-.862-.658 2.453-3.385z"
        fill="currentColor"
      />
      <path
        d="M31.741 51.871l.342.401 4.346-2.511v-.618l-4.734 2.268.046.46z"
        fill="currentColor"
      />
      <path
        d="M25.666 52.397l.48.796 5.937-.92v-.619l-6.108.625-.309.118z"
        fill="currentColor"
      />
      <path
        d="M19.809 51.641l.4.631 5.937.92v-.617l-6.239-1.44-.098.506z"
        fill="currentColor"
      />
      <path
        d="M15.857 49.143v.618l4.353 2.511v-.618l-1.966-2.78-2.387.269z"
        fill="currentColor"
      />
      <path
        d="M26.146 52.575l-5.936-.92-4.352-2.512-1.591-3.425 1.59-3.432 4.353-2.505 5.936-.92 5.937.92 4.346 2.511 1.59 3.426-1.59 3.425-4.346 2.511-5.937.92z"
        fill="currentColor"
      />
      <path
        d="M26.146 50.01l-.723 1.355.723 1.21 5.937-.92-.31-2.946-5.627 1.302zM31.386 38.723l-2.294-.645 1.873 1.63 4.063 1.513.198-.283-3.84-2.215zM35.226 40.938l1.203 1.348 1.59 3.431-1.906-1.847-.887-2.932z"
        fill="currentColor"
      />
      <path
        d="M36.08 44.304l.545-.342 1.394 1.756-1.59 3.425-1.612-2.156 1.263-2.683zM31.255 39.327l3.97 1.611 1.401 3.024-5.24-2.8-.131-1.835z"
        fill="currentColor"
      />
      <path
        d="M32.043 41.023l4.582 2.94-1.4 3.023-4.484-4.326 1.302-1.637zM33.345 47.21l1.88-.223 1.203 2.156-4.345 2.511-.697-2.452 1.959-1.992zM31.386 49.202l-5.24.809-.723-2.775.723-2.8 3.254-.98 1.986 5.746z"
        fill="currentColor"
      />
      <path
        d="M29.723 42.818l1.532-.085 3.97 4.254-3.839 2.215-2.294-5.227.63-1.157zM26.146 50.01v2.565l-5.937-.92.309-2.946 5.628 1.302zM20.907 38.723l2.288-.645-1.867 1.63-4.07 1.513-.19-.283 3.839-2.215zM17.067 40.938l-1.21 1.348-1.59 3.431 1.913-1.847.887-2.932z"
        fill="currentColor"
      />
      <path
        d="M16.213 44.304l-.553-.342-1.393 1.756 1.59 3.425 1.611-2.156-1.255-2.683zM21.038 39.327l-3.97 1.611-1.408 3.024 5.247-2.8.13-1.835z"
        fill="currentColor"
      />
      <path
        d="M20.249 41.023l-4.589 2.94 1.407 3.023 4.484-4.326-1.302-1.637zM18.947 47.21l-1.88-.223-1.21 2.156 4.353 2.511.697-2.452-1.96-1.992z"
        fill="currentColor"
      />
      <path
        d="M20.906 49.202l5.24.809v-5.575l-3.26-.98-1.98 5.746z"
        fill="currentColor"
      />
      <path
        d="M22.564 42.818l-1.526-.085-3.97 4.254 3.839 2.215 2.288-5.227-.631-1.157z"
        fill="currentColor"
      />
      <path
        d="M31.254 39.327l-2.163-1.249-2.945-.454-2.952.454-2.156 1.25-.789 1.695.789 1.71 2.156 1.242 2.952.46 2.945-.46 2.163-1.242.79-1.703-.79-1.703z"
        fill="currentColor"
      />
      <path
        d="M36.784 40.412l-11.709 6.759V36.126l11.709-6.765v11.051z"
        fill="currentColor"
      />
      <path
        d="M20.657 34.988l4.418 1.138 11.71-6.765-9.566-5.523-11.71 6.759 5.148 4.391z"
        fill="currentColor"
      />
      <path
        d="M25.075 47.17l-9.565-5.528V30.597l9.565 5.529V47.17zM26.995 24.792l-9.303 5.377 7.6 4.386 9.31-5.372-7.607-4.391z"
        fill="currentColor"
      />
      <path
        d="M25.075 34.58l.217-.025 9.31-5.372v.31l-9.31 5.37-.217-.282z"
        fill="currentColor"
      />
      <path
        d="M17.692 30.17v.302l7.6 4.392v-.31l-7.6-4.385zM35.85 40.123l-9.309 5.371v-8.776l9.31-5.378v8.783z"
        fill="currentColor"
      />
      <path
        d="M26.41 36.895l.131-.178 9.31-5.377-.27-.151-9.303 5.37.132.336z"
        fill="currentColor"
      />
      <path
        d="M26.541 45.494l-.263-.151V36.56l.263.157v8.777zM1.973 53.731l-.657.27-.927-1.998v-.362l.743.283.841 1.807zM14.234 51.64l.007.362-.934 2-.5-.389 1.427-1.972z"
        fill="currentColor"
      />
      <path
        d="M10.579 55.23l.197.23 2.531-1.459v-.361l-2.754 1.321.026.27z"
        fill="currentColor"
      />
      <path
        d="M7.035 55.54l.276.46 3.465-.54v-.354l-3.563.361-.178.073z"
        fill="currentColor"
      />
      <path
        d="M3.616 55.1l.237.36L7.31 56v-.362l-3.636-.834-.059.295z"
        fill="currentColor"
      />
      <path
        d="M1.315 53.64V54l2.538 1.46v-.355l-1.15-1.624-1.388.157z"
        fill="currentColor"
      />
      <path
        d="M7.311 55.638l-3.458-.532-2.537-1.466-.927-1.999.927-1.999 2.537-1.466 3.458-.532 3.465.532 2.531 1.466.927 1.999-.927 1.999-2.53 1.466-3.466.532z"
        fill="currentColor"
      />
      <path
        d="M7.311 54.146l-.42.789.42.703 3.465-.532-.184-1.723-3.28.763zM10.369 47.558l-1.335-.374 1.091.953 2.367.887.119-.17-2.242-1.296z"
        fill="currentColor"
      />
      <path
        d="M12.61 48.853l.704.79.927 1.998-1.118-1.078-.513-1.71z"
        fill="currentColor"
      />
      <path
        d="M13.104 50.82l.322-.205.815 1.026-.927 1.999-.94-1.256.73-1.565zM10.29 47.913l2.32.94.816 1.762-3.057-1.63-.079-1.072z"
        fill="currentColor"
      />
      <path
        d="M10.75 48.906l2.675 1.71-.822 1.768-2.61-2.525.756-.953zM11.513 52.509l1.091-.125.71 1.256-2.537 1.466-.408-1.433 1.144-1.164zM10.368 53.673l-3.057.473-.42-1.617.42-1.637 1.9-.566 1.157 3.347z"
        fill="currentColor"
      />
      <path
        d="M9.402 49.952l.888-.053 2.314 2.485-2.235 1.289-1.335-3.044.368-.677zM7.312 54.146v1.492l-3.458-.532.177-1.723 3.28.763zM4.255 47.558l1.341-.374-1.091.953-2.374.887-.111-.17 2.235-1.296zM2.02 48.853l-.704.79-.927 1.998 1.11-1.078.52-1.71z"
        fill="currentColor"
      />
      <path
        d="M1.52 50.82l-.323-.205-.808 1.026.927 1.999.94-1.256-.737-1.565zM4.333 47.913l-2.314.94-.822 1.762 3.057-1.63.08-1.072z"
        fill="currentColor"
      />
      <path
        d="M3.873 48.906l-2.676 1.71.822 1.768 2.617-2.525-.763-.953zM3.11 52.509l-1.091-.125-.704 1.256 2.538 1.466.401-1.433-1.144-1.164zM4.254 53.673l3.057.473v-3.254l-1.9-.566-1.157 3.347z"
        fill="currentColor"
      />
      <path
        d="M5.228 49.952l-.894-.053-2.314 2.485 2.235 1.289 1.341-3.044-.368-.677z"
        fill="currentColor"
      />
      <path
        d="M10.29 47.913l-1.256-.73-1.723-.262-1.715.263-1.263.73-.46.992.46.993 1.263.73 1.715.263 1.723-.263 1.256-.73.46-.993-.46-.993z"
        fill="currentColor"
      />
      <path
        d="M20.026 35.744l-9.388 10.21-1.289.75.296-.507-.493-.282-1.565.9-1.735 1.828v.782l.5.29.926-.914 12.669-7.219.578-.756-.5-.289-7.007 4.05 7.008-7.686.5-.867-.5-.29z"
        fill="currentColor"
      />
      <path
        d="M20.525 36.034l-9.388 10.21-1.493.861v-.907l-1.564.907-1.73 1.828v.782l14.175-8.185v-.703l-7.876 4.543 7.876-8.567v-.77zM41.097 14.884l.177-1.104-.078-1.769-.139-.158-.322.027v9.513l.303.17.125-.414-.066-5.246 1.348 4.504.295.17.093-.394-1.736-5.299z"
        fill="currentColor"
      />
      <path
        d="M41.281 12.018l-.243.032-.303-.17.362-.21.296.177-.112.17z"
        fill="currentColor"
      />
      <path
        d="M41.392 15.055v-3.208l-.355.204v9.513l.355-.204v-5.286l1.348 4.503.388-.223-1.736-5.3z"
        fill="currentColor"
      />
      <path
        d="M42.011 11.834l-.73-.914-.848-.487-.736.066-.42.605v.98l.42 1.09.736.915.849.486.73-.066.427-.598v-.98l-.428-1.097z"
        fill="currentColor"
      />
      <path
        d="M41.281 11.906l.73-.072.427 1.097.027 1.578-1.105-1.854-.079-.75z"
        fill="currentColor"
      />
      <path
        d="M39.92 10.111l1.362.809.73.914-.48.283-1.289-1.368-.322-.638zM38.132 9.552l-.072-.512-1.61.144-.224.132.447.368 1.46-.132zM41.302 18.112l.23-.131.933-1.322-.434-.177-.73 1.63z"
        fill="currentColor"
      />
      <path
        d="M42.242 14.47l.223.04v2.15l-.23.13-.177-2.235.184-.085z"
        fill="currentColor"
      />
      <path
        d="M41.137 12.11l.394.006.934 2.393-.23.132-1.079-2.393-.02-.138z"
        fill="currentColor"
      />
      <path
        d="M39.605 10.098l.315.013 1.61 2.005-.23.132-1.866-2.005.17-.145z"
        fill="currentColor"
      />
      <path
        d="M37.83 9.171l.23-.131 1.86 1.071-.23.132-1.446-.132-.414-.94z"
        fill="currentColor"
      />
      <path
        d="M41.3 12.248l-1.61-2.005-1.86-1.072-1.605.145-.933 1.321v2.143l.933 2.4 1.605 2.005 1.86 1.072 1.61-.145.934-1.321v-2.15l-.933-2.393z"
        fill="currentColor"
      />
      <path
        d="M40.953 12.452l-1.177-1.466-1.36-.79-1.178.106-.683.966v1.572l.683 1.755 1.177 1.466 1.361.782 1.177-.105.677-.966V14.2l-.677-1.748z"
        fill="currentColor"
      />
      <path
        d="M40.624 12.642l-.736-.92-.848-.487-.736.066-.421.598v.987l.42 1.09.737.915.848.493.736-.066.428-.605v-.98l-.428-1.09z"
        fill="currentColor"
      />
      <path
        d="M39.664 12.86l-.401-.237-.29.164v.473l.29.5.4.23.29-.164v-.467l-.29-.5z"
        fill="currentColor"
      />
      <path
        d="M36.587 15.022l.006.119.027.033 2.978-1.723v-.125l-3.011 1.696z"
        fill="currentColor"
      />
      <path
        d="M36.56 14.871l2.958-1.676.079.131-2.978 1.716-.105-.131.046-.04z"
        fill="currentColor"
      />
      <path
        d="M39.407 13.129l-2.971 1.716.013.066h.092l2.978-1.716-.112-.066z"
        fill="currentColor"
      />
      <path
        d="M36.54 14.91l-.105-.065-.079.046v.125l.08.138.105.059.078-.04v-.131l-.078-.131z"
        fill="currentColor"
      />
      <path
        d="M36.41 15.22l.006.387.098.086.217-.132v-.394l-.322.052z"
        fill="currentColor"
      />
      <path
        d="M36.33 14.746h.158l.243.42-.217.126-.335-.421.15-.125z"
        fill="currentColor"
      />
      <path
        d="M36.146 14.549l-.223.125.059.197h.29l.216-.125-.342-.197z"
        fill="currentColor"
      />
      <path
        d="M36.271 14.87l-.348-.196-.243.138v.4l.243.421.348.198.244-.138v-.401l-.244-.421zM45.134 22.846v.13l.118.067.033-.053v-.105l-.151-.04z"
        fill="currentColor"
      />
      <path
        d="M45.443 22.957l-.02.086h-.171v-.132l.033-.026.138.007.02.065z"
        fill="currentColor"
      />
      <path
        d="M45.541 22.846v.131l-.118.066v-.132l.059-.105.06.04z"
        fill="currentColor"
      />
      <path
        d="M45.423 22.911l.118-.066v-.098l-.118-.072h-.17l-.12.072v.099l.12.065h.17z"
        fill="currentColor"
      />
      <path
        d="M45.2 20.762v2.064l.078.046.02-.033v-2.051l-.099-.026zM45.475 20.762v2.064l-.079.046-.052-.986.052-1.078.027-.046h.052z"
        fill="currentColor"
      />
      <path
        d="M45.397 22.872h-.119v-2.064l.027-.027.092.007v2.084z"
        fill="currentColor"
      />
      <path
        d="M45.397 20.643h-.119l-.079.053v.065l.08.046h.117l.08-.046v-.065l-.08-.053z"
        fill="currentColor"
      />
      <path
        d="M45.24 5.667v15.075l.058.033.014-.026V5.687l-.073-.02z"
        fill="currentColor"
      />
      <path
        d="M45.39 20.729l-.012.046h-.08V5.7l.014-.013h.066l.013 15.042z"
        fill="currentColor"
      />
      <path
        d="M45.436 5.667v15.075l-.059.033V5.7l.026-.053.033.02z"
        fill="currentColor"
      />
      <path
        d="M45.377 5.588h-.079l-.059.033v.046l.06.033h.078l.06-.033V5.62l-.06-.033z"
        fill="currentColor"
      />
      <path
        d="M45.187 5.114v.776l.092.046.02-.04v-.749l-.112-.033z"
        fill="currentColor"
      />
      <path
        d="M45.416 5.87l-.02.067h-.118v-.77l.02-.026.099.013.02.717z"
        fill="currentColor"
      />
      <path
        d="M45.489 5.115v.775l-.092.046v-.769l.046-.072.046.02z"
        fill="currentColor"
      />
      <path
        d="M45.397 4.996h-.118l-.093.046v.073l.093.052h.118l.092-.052v-.073l-.092-.046zM46.974 28.616l-.476.834.177.101.476-.834-.177-.1z"
        fill="currentColor"
      />
      <path
        d="M46.979 28.615l-.48.832 1.532.883.48-.831-1.532-.884z"
        fill="currentColor"
      />
      <path
        d="M45.66 34.035l.066-.118 4.26-3.583.48-4.622.072-.125 11.236 4.747 12.478 8.948-.066.118-2.893 3.596-1.847 4.615-.072.118-13.044-5.575-10.67-8.119z"
        fill="currentColor"
      />
      <path
        d="M50.313 36.56l-4.588-2.643 4.74-8.205 4.582 2.643-.789 1.617-3.241 5.496-.704 1.092z"
        fill="currentColor"
      />
      <path
        d="M55.048 28.36l-4.74 8.203.177.102 4.74-8.203-.177-.102z"
        fill="currentColor"
      />
      <path
        d="M55.047 39.295l-4.582-2.643 4.74-8.205 4.582 2.643-.789 1.617-3.24 5.496-.71 1.092z"
        fill="currentColor"
      />
      <path
        d="M59.795 31.096l-4.76 8.191.176.102 4.76-8.19-.176-.103z"
        fill="currentColor"
      />
      <path
        d="M59.787 42.03l-4.582-2.643 4.734-8.205 4.589 2.643-.79 1.617-3.24 5.496-.71 1.091z"
        fill="currentColor"
      />
      <path
        d="M64.53 33.836l-4.744 8.2.176.102 4.745-8.2-.177-.102z"
        fill="currentColor"
      />
      <path
        d="M64.527 44.771l-4.583-2.65 4.734-8.204 4.589 2.65-.79 1.617-3.247 5.496-.703 1.091z"
        fill="currentColor"
      />
      <path
        d="M69.27 36.57l-4.762 8.19.176.102 4.763-8.189-.177-.102z"
        fill="currentColor"
      />
      <path
        d="M69.268 47.506l-4.59-2.65 4.74-8.204 4.583 2.65-.782 1.617-3.248 5.496-.703 1.091z"
        fill="currentColor"
      />
      <path
        d="M69.445 47.611l-.177-.105L74 39.301l.184.099-4.74 8.211zM47.408 41.595l-4.589-2.642 2.84-4.918 4.583 2.65-.79 1.617-1.34 2.202-.704 1.091z"
        fill="currentColor"
      />
      <path
        d="M50.255 36.691l-2.857 4.902.176.103 2.857-4.902-.176-.103z"
        fill="currentColor"
      />
      <path
        d="M52.148 44.33l-4.588-2.643 2.833-4.917 4.589 2.65-.789 1.616-1.341 2.203-.704 1.091z"
        fill="currentColor"
      />
      <path
        d="M52.326 44.435l-.178-.105 2.834-4.91.178.098-2.834 4.917z"
        fill="currentColor"
      />
      <path
        d="M56.882 47.072l-4.582-2.65 2.833-4.917 4.583 2.65-.783 1.617-1.34 2.202-.71 1.098z"
        fill="currentColor"
      />
      <path
        d="M57.06 47.17l-.178-.098 2.833-4.918.178.105-2.834 4.911z"
        fill="currentColor"
      />
      <path
        d="M61.621 49.807l-4.582-2.65 2.834-4.91 4.582 2.642-.789 1.617-1.335 2.203-.71 1.098z"
        fill="currentColor"
      />
      <path
        d="M61.799 49.905l-.178-.098 2.834-4.918.177.105-2.833 4.911z"
        fill="currentColor"
      />
      <path
        d="M66.362 52.542l-4.589-2.65 2.84-4.91 4.583 2.642-.79 1.617-1.34 2.21-.704 1.09z"
        fill="currentColor"
      />
      <path
        d="M69.188 47.632l-2.822 4.922.177.102 2.821-4.923-.176-.101zM55.12 28.236l-4.583-2.649 2.834-4.911 4.582 2.643-.789 1.617-1.341 2.21-.704 1.09z"
        fill="currentColor"
      />
      <path
        d="M57.957 23.326l-2.84 4.912.177.102 2.839-4.912-.176-.102z"
        fill="currentColor"
      />
      <path
        d="M59.86 30.971l-4.59-2.65 2.834-4.91 4.589 2.643-.789 1.617-1.341 2.209-.704 1.091z"
        fill="currentColor"
      />
      <path
        d="M62.683 26.059L59.86 30.98l.177.101 2.822-4.922-.177-.101z"
        fill="currentColor"
      />
      <path
        d="M64.593 33.706l-4.582-2.65 2.833-4.91 4.59 2.65-.79 1.617-1.34 2.202-.711 1.091z"
        fill="currentColor"
      />
      <path
        d="M67.429 28.792l-2.841 4.91.176.103 2.841-4.911-.176-.102z"
        fill="currentColor"
      />
      <path
        d="M69.333 36.441l-4.582-2.643 2.834-4.917 4.582 2.642-.782 1.624-1.342 2.203-.71 1.091z"
        fill="currentColor"
      />
      <path
        d="M72.159 31.52l-2.82 4.925.178.101 2.819-4.924-.177-.101z"
        fill="currentColor"
      />
      <path
        d="M74.073 39.176l-4.582-2.643 2.834-4.918 4.582 2.65-.789 1.617-1.334 2.203-.71 1.09z"
        fill="currentColor"
      />
      <path
        d="M76.91 34.264l-2.832 4.916.177.102 2.832-4.916-.176-.102z"
        fill="currentColor"
      />
    </svg>
  )
}
